export * from './loading/loading.component';
export * from './notices/notices.component';
export * from './error/error.component';
export * from './product-detail/product-detail.component';
export * from './requisition-products/requisition-products.component';
export * from './requisition-authorisation-trail/requisition-authorisation-trail.component';



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/index.ts